module.exports = __webpack_public_path__ + "static/media/A1-24-Groxxyn-cod122.c47b3629.png";